"use client";
// src/components/Sidebar/SidebarKaitouMonitorLink.tsx
//
// 怪答用紙モニター向けのサイドバー常設リンク（2026-07-30・CEO確定）。
// SidebarCardType.tsx内の showAddEditionLink と同じ「フラグの真偽でレンダリング判定」
// の型を踏襲しつつ、既存のアコーディオン（SidebarCardType等）には埋め込まず、
// SidebarHeaderの直後に独立した常設リンクとして配置する（Sidebar.tsx参照）。
// 判定ロジックはホーム画面バナー（KaitouMonitorBanner.tsx）と同じ
// useKaitouMonitorAccess フックを共有する。

import Link from "next/link";
import { useKaitouMonitorAccess } from "@/hooks/useKaitouMonitorAccess";

export default function SidebarKaitouMonitorLink() {
  const { shouldShow, kaitouUrl } = useKaitouMonitorAccess();

  if (!shouldShow || !kaitouUrl) return null;

  return (
    <Link
      href={kaitouUrl}
      className="mb-4 block rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800 hover:bg-amber-100 transition-colors"
    >
      🎴 KATARUTA Sheetホスト
    </Link>
  );
}
